import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Building2 } from 'lucide-react';

const Impressum = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-gray-700 to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Building2 className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {language === 'de' ? 'Impressum' : 'Legal Notice'}
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2>Herausgeber der Internetseite:</h2>
            <p className="text-xl font-semibold">Surf- und Kitemotion</p>
            <p>
              Peter Müller<br />
              Palm Royale Soma Bay (ex InterContinental Abu Soma)<br />
              Red Sea Hurghada Ägypten
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:peter@surfmotion.com" className="text-cyan-600 hover:text-cyan-800">peter@surfmotion.com</a>
            </p>
            <p>
              <strong>Geschäftsführer:</strong> Peter Müller
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4">Disclaimer</h2>
            
            <h3 className="text-xl font-semibold mt-6 mb-3">Rechtliche Hinweise</h3>
            <p>
              Die Nutzung der Internetseiten unterliegt nachfolgenden Bestimmungen.
              Mit dem Zugriff auf unsere Webseiten erklären Sie sich mit diesen Bedingungen einverstanden.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Inhalt</h3>
            <p>
              Der Herausgeber dieser Homepage übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, 
              Vollständigkeit oder Qualität der angebotenen Informationen. Haftungsansprüche gegen den Herausgeber, 
              die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung 
              fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich komplett ausgeschlossen. 
              Alle Angebote sind freibleibend und unverbindlich.
            </p>
            <p>
              Der Herausgeber behält sich ausdrücklich das Recht vor, Teile der Seiten oder das gesamte Angebot 
              ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung 
              zeitweise oder endgültig einzustellen.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Verweise und Links</h3>
            <p>
              Mit Urteil vom 12. Mai 1998 hat das Landgericht Hamburg entschieden, daß durch die Ausbringung 
              eines Links die Inhalte der gelinkten Seite ggf. mit zu verantworten sind. Dies kann – so das LG – 
              nur dadurch verhindert werden, daß man sich ausdrücklich von diesen Inhalten distanziert.
            </p>
            <p>
              Wir ermöglichen auf unserer Page Links zu anderen Seiten im Internet. Für all diese Links gilt: 
              Wir möchten ausdrücklich betonen, daß der Herausgeber dieser Internetseite keinerlei Möglichkeit 
              der Einflussnahme auf die Gestaltung und die Inhalte der gelinkten Seiten hat. Deshalb distanzieren 
              wir uns hiermit ausdrücklich von allen Inhalten aller gelinkten Seiten auf unserer Homepage. 
              Diese Erklärung gilt für alle auf unseren Seiten aufgeführten Links und für alle Inhalte der Seiten, 
              zu denen diese führen!
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Rechtswirksamkeit dieses Haftungsausschlusses</h3>
            <p>
              Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese 
              Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden 
              Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile 
              dieses Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Urheberrecht</h3>
            <p>
              Der Herausgeber ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Objekte 
              zu beachten, von ihm selbst erstellte Objekte zu nutzen oder auf lizenzfreie Objekte zurückzugreifen.
            </p>
            <p>
              Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und 
              Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts 
              und den Besitzrechten der jeweiligen eingetragenen Eigentümer.
            </p>
            <p>
              Das Copyright für veröffentlichte, vom Herausgeber selbst erstellte Objekte bleibt allein beim 
              Herausgeber der Seiten. Eine Vervielfältigung oder Verwendung solcher Objekte in anderen 
              elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Herausgebers 
              nicht gestattet.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Affiliate-Links & Partnerprogramme</h3>
            <p>
              Diese Website enthält sogenannte Affiliate-Links zu Partnerprogrammen (u.a. Amazon PartnerNet, 
              Booking.com). Wenn Sie über diese Links Produkte oder Dienstleistungen kaufen bzw. buchen, 
              erhalten wir eine kleine Provision. Für Sie entstehen dabei keine zusätzlichen Kosten. 
              Die Einnahmen helfen uns, diese Website zu betreiben und weiterhin kostenlose Inhalte anzubieten.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Datenschutz</h3>
            <p>
              Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher 
              Daten (E-Mail-Adressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens 
              des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen 
              Dienste ist – soweit technisch möglich und zumutbar – auch ohne Angabe solcher Daten bzw. unter 
              Angabe anonymisierter Daten oder eines Pseudonyms gestattet.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;
